import { initCarousel } from '@/braun/Controllers/BraunCarouselController';

const initHighlightsCarousel = item => {
  initCarousel(
    item,
    {
      slidesPerViewXl: 3,
      slidesPerViewL: 3,
      slidesPerViewM: 2,
      slidesPerViewXs: 1,

      spaceBetweenXl: 20,
      spaceBetweenL: 20,
      spaceBetweenM: 10,
      spaceBetweenXs: 10,

      hideScrollbar: false,
    },
    {
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      watchOverflow: true,
      roundLengths: true,
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
    },
  );
};

export default () => {
  const highlightsSliders = document.querySelectorAll('.bra-highlights__slide');
  Array.from(highlightsSliders).forEach(item => initHighlightsCarousel(item));
};
